export const API_CONFIG = {
    baseUrl: '/api/v1/webview/',
    staticBaseUrl: 'https://managerapi.frafsb.fix.ru/static/products/'
}   